"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tray = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const react_jss_1 = __importDefault(require("react-jss"));
// Re-resizable
const re_resizable_1 = require("re-resizable");
const icons_1 = require("../../icons");
const text_1 = require("../../utils/text");
const tray_style_1 = __importDefault(require("./tray.style"));
const Tray = ({ classes, portalEl, title, children, isLeftSide = false, width = 450, collapsedWidth = 54, resizable = true, minWidth = 200, onResize, onClose }) => {
    const [collapsed, setCollapsed] = react_1.useState(false);
    const [currentWidth, setCurrentWidth] = react_1.useState(width);
    const [isResizing, setIsResizing] = react_1.useState(false);
    const [resizingWidth, setResizingWidth] = react_1.useState(width);
    // work out the current tray width
    const isResizable = resizable && !collapsed;
    let usedWidth = collapsed ? collapsedWidth : currentWidth;
    if (isResizing) {
        usedWidth = resizingWidth;
    }
    const trayEnable = react_1.useMemo(() => ({
        top: false,
        right: isResizable && isLeftSide,
        bottom: false,
        left: isResizable && !isLeftSide,
        topRight: false,
        bottomRight: false,
        bottomLeft: false,
        topLeft: false
    }), [isResizable, isLeftSide]);
    const onResizeStart = react_1.useCallback(() => setIsResizing(true), []);
    const onResizeInternal = react_1.useCallback((...args) => {
        const d = args[3];
        setResizingWidth(currentWidth + d.width);
    }, [currentWidth]);
    const onResizeStop = react_1.useCallback(() => {
        setCurrentWidth(resizingWidth);
        setIsResizing(false);
        if (onResize)
            onResize(resizingWidth);
    }, [resizingWidth, onResize]);
    const trayContent = react_1.useMemo(() => {
        const parsedTitle = typeof title === 'string' ? text_1.parseBoldMarkdown(title) : title;
        return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsxs("div", Object.assign({ className: classes.trayTitleContainer, "data-is-collapsed": collapsed, "data-is-inverted": isLeftSide }, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.trayCollapseIcon, "data-is-collapsed": collapsed, "data-is-inverted": isLeftSide, onClick: () => setCollapsed(!collapsed), "data-cy": "collapse-toggle" }, { children: jsx_runtime_1.jsx(icons_1.Icon, { name: "CircleArrowRight", size: 32 }, void 0) }), void 0),
                        !collapsed && jsx_runtime_1.jsx("div", Object.assign({ className: classes.trayTitle }, { children: parsedTitle }), void 0)] }), void 0),
                collapsed && (jsx_runtime_1.jsx("div", Object.assign({ className: classes.trayCollapsedTitleWrapper }, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.trayCollapsedTitle }, { children: parsedTitle }), void 0) }), void 0)),
                collapsed && onClose && (jsx_runtime_1.jsx("div", Object.assign({ className: classes.trayCloseIcon, onClick: onClose, "data-cy": "close-tray" }, { children: jsx_runtime_1.jsx(icons_1.Icon, { name: "CircleCross", size: 32 }, void 0) }), void 0)),
                jsx_runtime_1.jsx("div", Object.assign({ className: classes.trayBody, "data-is-hidden": collapsed }, { children: children }), void 0)] }, void 0));
    }, [classes, collapsed, isLeftSide, title, onClose, children]);
    const resizableStyle = react_1.useMemo(() => ({ transition: isResizing ? 'none' : 'width .25s' }), [isResizing]);
    const resizableSize = react_1.useMemo(() => ({
        width: usedWidth,
        height: '100%'
    }), [usedWidth]);
    return react_dom_1.createPortal(jsx_runtime_1.jsx(re_resizable_1.Resizable, Object.assign({ className: classes.tray, handleWrapperClass: classes.handleWrapper, style: resizableStyle, minWidth: isResizing ? minWidth : 0, size: resizableSize, enable: trayEnable, onResizeStart: onResizeStart, onResize: onResizeInternal, onResizeStop: onResizeStop }, { children: trayContent }), void 0), portalEl);
};
exports.Tray = Tray;
exports.default = react_jss_1.default(tray_style_1.default)(react_1.memo(exports.Tray));
//# sourceMappingURL=index.js.map